








































































































































































import { Component, Mixins } from 'vue-property-decorator';
import DetailMixin from '@/mixins/DetailMixin';
import FieldDefs from './FieldDefs';
import { VForm } from '@/interfaces';

@Component
export default class ManageCustomersDetail extends Mixins(DetailMixin) {
  public tableCfg = FieldDefs;
  public formValid = false;


  public get theForm() {
    return (this.$refs.form as unknown) as VForm;
  }

}
